module.exports = __webpack_public_path__ + "files/dd69025c27c69f92aea1434e9c25af83.svg";